import { createRoot } from "react-dom/client";
import * as serviceWorker from "./serviceWorker";
import "./tailwind.css";
import "./index.scss";
import { RouterProvider } from "react-router";
import { router } from "./router/router";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);
root.render(<RouterProvider router={router} />);

serviceWorker.register();
